module.exports = __webpack_public_path__ + "static/media/houniao-2@2x.d4063f82.png";